import React from 'react';
import { useSnapshot } from 'valtio';
import { state } from '../store/global';
import { Outlet, Navigate } from 'react-router-dom';

export default function ProtectedLoginRoute() {
  const snap = useSnapshot(state);

  const OnlyEmailLogin = snap?.user?.id ? true : false;
  console.log('OnlyEmailLogin: ', OnlyEmailLogin);

  // Redirect if not authenticated
  return OnlyEmailLogin ? <Outlet /> : <Navigate to="/login" replace />;
}
